"use client";

import Script from "next/script";
import { useEffect, useState, useRef } from "react";

interface ZohoChatbotProps {
  widgetCode: string;
}

export default function ZohoChatbot({ widgetCode }: ZohoChatbotProps) {
  const [shouldLoadZoho, setShouldLoadZoho] = useState(false);
  const isInitialized = useRef(false);

  useEffect(() => {
    // Listen for CONTEXT_INIT message from ThinkstackChatbot
    const handleMessage = (event: MessageEvent) => {
      if (!event || !event.data) return false;

      let data;
      try {
        data = event.data && typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      } catch (e) {
        return false;
      }

      if (data.type && data.type === "CONTEXT_INIT") {
        // Check if Zoho is already initialized to prevent multiple initializations
        if (!isInitialized.current) {
          isInitialized.current = true;
          setShouldLoadZoho(true);
        }
      }
    };

    // Add message event listener
    window.addEventListener("message", handleMessage);

    // Cleanup
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  // Only render Zoho scripts when ThinkstackChatbot context is initialized
  if (!shouldLoadZoho) {
    return null;
  }

  return (
    <>
      {/*
        Load Zoho SalesIQ only when ThinkstackChatbot sends CONTEXT_INIT message.
        This prevents unnecessary preconnect requests and ensures single initialization.
      */}
      <Script
        id="zoho-salesiq-init"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}`,
        }}
      />
      <Script
        id="zsiqscript"
        src={`https://salesiq.zohopublic.com/widget?wc=${widgetCode}`}
        strategy="lazyOnload"
        defer
      />

      {/* CSS injection for Zoho */}
      <Script
        id="zoho-salesiq-css"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            (function(){
              var existing = document.getElementById("zoho-salesiq-style");
              if (!existing) {
                var st = document.createElement("style");
                st.id = "zoho-salesiq-style";
                st.textContent = ".zsiq_floatmain{display:none!important}#zsiq_float{display:none!important}";
                document.head.appendChild(st);
              }
            })();
          `,
        }}
      />
    </>
  );
}
